import { defineStore } from 'pinia';
import { setToken, clearToken, setOrgId, getOrgId } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { type UserState } from './types';
import { $fetch } from '@/utils/fetch';
import { ref } from 'vue';

const ORG_ID_KEY = 'openatom-talent-profile-organization-id';
const useUserStore = defineStore('user', () => {
  const getInitUser = (): UserState => ({
    userId: undefined,
    name: undefined,
    photo: undefined,
    username: undefined,
    nickname: undefined,
    email: undefined,
    roles: [],
  });

  const user = ref<UserState>(getInitUser());

  const organizationId = ref('')
  const organizations = ref<Record<string, any>>([]);

  const setInfo = (partial: Partial<UserState>) => {
    user.value = { ...user.value, ...partial };
  }

  const resetInfo = () => {
    user.value = getInitUser();
  }

  const userSyncOrg = async () => {
    await $fetch('/api/user/login/sync', {
    });
  }

  const getUserRole = async (id: string) => {
    const { data, isSuccess } = await $fetch(`/api/user/type/${id}`, {
      method: 'GET',
    })

    if (isSuccess) {
      setInfo({
        ...user.value,
        roles: Array.isArray(data) ? data.map(item => item.replace(/_/g, '-')) : [],
        // roles: ['admin'],
      });
    }
  }

  const fetchOrganizations = async () => {
    const { isSuccess, data } = await $fetch('/api/user/organization', {
      method: 'GET',
    })

    if (isSuccess) {
      // 临时前端排序
      // data.sort((a: { id: number; }, b: { id: number; }) => a.id - b.id);
      if (!data) {
        organizations.value = []
        setOrgId('');
        return
      }
      organizations.value = data
      const defaultId = getOrgId() ? getOrgId() : organizations.value.find((item: any) => item.power === 1) ? organizations.value.find((item: any) => item.power === 1)?.orgId : organizations.value[0].orgId

      if (defaultId) {
        setOrgId(defaultId);
      }

      organizationId.value = defaultId;

      await getUserRole(user.value.userId || '')
    }
  }

  // Get user's information
  const fetchInfo = async () => {

    if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
      setInfo({
        userId: '1',
        name: '王立群',
        photo: 'https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png',
        email: 'wangliqun@email.com',
        username: 'wangliqun',
        nickname: 'wlq',
        roles: ['admin'],
      });

      return {
        isSuccess: true,
        code: 0,
      };
    }
    else {
      const { isSuccess, data, msg, code } = await $fetch('/api/oauth/v1/getUserByToken');
      if (isSuccess) {
        setInfo({
          userId: data.uid,
          name: data.name,
          photo: data.photo,
          email: data.email,
          username: data.username,
          nickname: data.nickname,
          roles: [''],
        });


        if (!getOrgId()) {
          await userSyncOrg()
        }
        await fetchOrganizations()
      }

      return { isSuccess, msg, code: Number(code) };
    }
  }

  // Login
  const login = async (code: string) => {
    //登录退出后清除本地缓存的组织id
    localStorage.removeItem(ORG_ID_KEY)
    const { isSuccess, data, msg } = await $fetch('/api/oauth/v1/token', {
      errorMessage: false,
      data: {
        code,
      },
    });

    if (isSuccess) {
      setToken(data.access_token);
    }
    else {
      clearToken();
    }

    return { isSuccess, msg };
  }

  const logoutCallBack = () => {
    resetInfo();
    clearToken();
    removeRouteListener();
  }

  // Logout
  const logout = async () => {
    await $fetch('/api/oauth/v1/logout', {
      errorMessage: false,
    });

    logoutCallBack();
  }

  return { user, setInfo, resetInfo, fetchInfo, login, logout, organizationId, userSyncOrg, organizations, fetchOrganizations };
});

export default useUserStore;
